import { connect } from 'react-redux';
import MiniWishlistOptions from './miniWishlistOptions';

const mapStateToProps = ({ loggedUserInfo, miniWishlist }) => ({
  entries: miniWishlist.entries,
  accountIsLogged: loggedUserInfo.accountIsLogged,
});

export default connect(mapStateToProps)(MiniWishlistOptions);
